<template>
	<div class="wrapper flex flex-col justify-center h-full">
		<div class="flex justify-center">
			<div class="w-10/12 sm:w-6/12 md:w-5/12 lg:w-4/12 xl:w-3/12 flex flex-col">
				<img alt="Vue logo" class="w-full p-8" src="../../assets/logo.svg" />
				<div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
					<p class="text-center mb-5 px-5">
						{{ $t('enter_e_mail_for_password_change') }}
					</p>

					<div class="mb-6 relative">
						<input
							class="shadow appearance-none input w-full py-2 px-3 pl-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
							id="email"
							type="email"
							:placeholder="$t('e_mail')"
							v-model="email"
							ref="email"
							@keyup.enter="resetPassword"
						/>
						<div class="absolute flex border border-transparent left-0 top-0 h-full w-10">
							<div class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-gray-600 text-lg h-full w-full">
								<font-awesome-icon icon="envelope" class="h-5 w-5"></font-awesome-icon>
							</div>
						</div>
					</div>

					<div class="flex flex-col md:flex-row justify-end">
						<BaseButton @click="resetPassword" class="btn-blue">{{ $t('reset') }}</BaseButton>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import apiDefaults from '@/api/defaultConfiguration';
import { AuthenticationApiFactory } from '@/api/generated';
import { _regxp } from '@/plugins/Utils';
import BaseButton from '@/components/forms/buttons/BaseButton';

export default {
	name: 'ResetPassword',
	components: { BaseButton },
	data() {
		return {
			email: '',
			regxp: _regxp(),
		};
	},
	mounted() {
		const input = this.$refs.email;
		input.focus();
	},
	methods: {
		resetPassword() {
			const match = this.email.match(this.regxp.email);
			if (!(match !== null && match[0] === this.email))
				this.$swal(this.$t('general.attention').toString(), this.$t('check_e_mail').toString(), 'error');
			else {
				return AuthenticationApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.resetPasswordPost({
						email: this.email,
					})
					.then(response => {
						this.$swal(this.$t('general.success').toString(), this.$t('password_reset_e_mail_sent').toString(), 'success').then(() => {
							this.$router.push({ name: 'login' });
						});
					})
					.catch(error => {
						const response = error.response;
						if (response && response.status === 405) {
							this.$swal(this.$t('general.error').toString(), this.$t('company_account_locked').toString(), 'error');
						}
					});
			}
		},
	},
};
</script>

<style lang="sass" scoped>
.wrapper
	background-color: #e9ecef
</style>
